import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { QueryDeliveryTimeSlots } from "../../apollo/queries";
import { useMutation, gql, useApolloClient } from "@apollo/client";
import { SetDeliverySlotForOrder} from '../../apollo/mutations';
import { LocationContext } from '../../context/Location';
import { FaArrowLeftLong } from "react-icons/fa6";

const QUERYTIMESLOTS = gql`
  ${QueryDeliveryTimeSlots}
`;

const SETDELIVERYSLOT = gql`
  ${SetDeliverySlotForOrder}
`;

export default function DeliverySlot(props) {

    const [selectAddress, setSelectAddress] = useState(false)
    const [deliveryTimeSlots, setDeliverTimeSlots] = useState([])
    const [selectedSlot, setSelectedSlot] = useState({})
    const [setDeliverySlot] = useMutation(SETDELIVERYSLOT);
    const [isLoading,setIsLoading] = useState(false);

    const { t } = useTranslation()
    const client = useApolloClient();
    const { location } = useContext(LocationContext)



    useEffect(()=>{
        queryDeliverySlots()
    },[])

    const queryDeliverySlots = async()=>{
        setIsLoading(true)
        try{
            const { data } = await client.query({
                query: QUERYTIMESLOTS,
                variables:{},
                fetchPolicy: 'no-cache',
              });
            setIsLoading(false)
            setDeliverTimeSlots(data?.queryDeliveryTimeSlots)
            if(data?.queryDeliveryTimeSlots?.length > 0){
              selectDeliveryTimeSlot(data?.queryDeliveryTimeSlots[0])
            }
        }
        catch(error){
            //console.log("🚀 ~ file: DeliverySlot.js ~ line 89 ~ queryDeliverySlots ~ error", error)
        }
    }

      const selectAnotherLocation = async (value) => {
        setSelectAddress(value)
      }

      const selectDeliveryTimeSlot = async(data)=>{
        let requestBody = {
            "slotId": data?.slotId,
            "date": data?.date
          }
        setIsLoading(true)
        let response = await setDeliverySlot({ variables:requestBody})
        setSelectedSlot(data)
        setIsLoading(false)
      }

      return (
        <>
        {isLoading ?
          <div className='flex justify-center'><div className={`loader ease-linear rounded-full border-2 border-t-8 border-gray-200 h-10 w-10`}></div></div>:
          <div className="flex flex-col justify-between pb-2 flex-1">
              <div className={`flex self-start align-left items-center text-md sm:text-md md:text-md lg:text-xl xl:text-xl gap-2 text-${props?.colors?.heading} font-bold`}>
                  <FaArrowLeftLong className={`hover:text-appThemeColorVeryDark text-lg sm:text-lg md:text-lg lg:text-2xl xl:text-2xl my-2 transition-transform ease-in-out cursor-pointer duration-200 active:scale-90 text-${props?.colors?.heading}`} onClick={()=>props?.setPageType('cart')} />
                  <div className={`text-md my-1 sm:text-md md:text-md text-${props?.colors?.heading}`}>{t("DeliverySlot")}</div>
                </div>
              <div>
                <div style={{backgroundColor:props?.Colors.colorTheme[props?.colors?.backgroundColor]}} className={`border border-appThemeColorAboveLight relative flex mb-3 p-2 bg-${props?.colors?.backgroundColor} dark:bg-${props?.colors?.backgroundColor} rounded text-left`}>
                  <div className="flex flex-col flex-1">
                    <p className={`text-${props?.colors?.heading} text-sm font-bold m-0`}>
                      Delivering to{" "}
                      <span className={`text-sm font-bold text-${props?.colors?.heading}`}>
                        {location?.label ? location?.label : "New Address"}
                      </span>
                    </p>
                    <p className={`text-sm m-0 text-${props?.colors?.heading}`}>
                      {(location?.details ? location?.details + ", " : "") +
                        (location?.deliveryAddress ? location?.deliveryAddress : "No Address Selected")}
                    </p>
                  </div>
                  <button
                    className="flex items-center mx-1.5 p-1 bg-transparent border-none"
                    onClick={()=>{props?.onAddressChange()}}
                  >
                    <span className="text-appThemeColorVeryDark text-sm pl-2 font-bold">Change</span>
                  </button>
                </div>
          
                {/* <div className="flex flex-col items-start mx-1.5 py-2.5 px-3.5 border border-gray-400 justify-center bg-white rounded-md my-1.5"> */}
                {deliveryTimeSlots?.length>0 && <div style={{backgroundColor:props?.Colors.colorTheme[props?.colors?.backgroundColor]}} className={`flex flex-col items-start border border-appThemeColorAboveLight relative mb-3 p-2 bg-${props?.colors?.backgroundColor} dark:bg-${props?.colors?.backgroundColor} rounded text-left`}>
                  <div className="flex items-center">
                    <p className={`text-${props?.colors?.heading} text-sm font-bold m-0 mr-1`}>
                      Select One of the Available Slots for Delivery
                    </p>
                  </div>
          
                  {deliveryTimeSlots?.map((item, index) => (
                    <button
                      key={index}
                      onClick={() => selectDeliveryTimeSlot(item)}
                      className={`flex flex-col items-start py-2.5 px-3.5 border justify-center rounded-md my-1.5 w-full cursor-pointer ${
                        item?.slotId === selectedSlot?.slotId
                          ? "bg-appThemeColorDark border-appThemeColorAboveLight"
                          : `bg-${props?.colors?.navColor} border-appThemeColorAboveLight`
                      }`}
                    >
                      <span
                        className={`text-[13px] ${
                          item?.slotId === selectedSlot?.slotId ? "font-normal text-white" : "font-normal"
                        } text-${props?.colors?.heading}`}
                      >
                        {item?.deliveryString}
                      </span>
                    </button>
                  ))}
                </div>}
              </div>
          
              <button
                disabled={!selectedSlot?.slotId}
                onClick={() =>props?.setPageType("orderReview")
                }
                className={`w-full text-white flex justify-center items-center rounded mt-1 sm:mt-0 p-3p my-2 text-sm sm:text-sm md:text-md  font-semibold ${selectedSlot?.slotId ? "bg-appThemeColorVeryDark" : "bg-appThemeColorVeryDark opacity-80 cursor-not-allowed"}`}
              >
                {t("CONTINUE")}
              </button>
            </div>
          }
        </>
          
      );
      
}